import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoLegalModalDialogModule } from '@shared/promo-legal-modal-dialog';
import { PipesModule } from '@shared/ui';
import { LinksModule } from '@shared/ui/links';
import {
  JbBackgroundImageModule,
  JbDialogLinkModule,
  JbFlagModule,
  JbImageModule,
  JbOverlayImageModule,
  JbProductBlockModule,
  JbPromoBlockModule,
  JbStarRatingModule,
  JbUtilsModule,
} from 'jb-component-library';

import {
  IsolatedProductBlockContainerComponent,
  isolatedProductBlockContainerResolver,
} from './isolated-product-block-container.component';

const MODULES = [
  CommonModule,
  JbProductBlockModule,
  JbFlagModule,
  JbDialogLinkModule,
  JbPromoBlockModule,
  JbOverlayImageModule,
  JbStarRatingModule,
  JbBackgroundImageModule,
  JbUtilsModule,
  JbImageModule,
  PromoLegalModalDialogModule,
  LinksModule,
  PipesModule,
];

const DECLARATIONS = [IsolatedProductBlockContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class IsolatedProductBlockContainerModule {
  static entry = IsolatedProductBlockContainerComponent;
  static componentDataResolver = isolatedProductBlockContainerResolver;
}
